import {
  hiringManagerJobsConstants,
  jobsConstants,
  mentorConstants,
  recruiterJobConstants,
} from "../../_constants";

const initialState = {};

//login reducer
export const get_shared_job_detail_reducer = (state = initialState, action) => {
  switch (action.type) {
    case jobsConstants.GET_SHARED_JOB_DETAIL_ACTION_REQUEST:
      return {
        type: "alert-success",
        message: action.payload,
      };
    case jobsConstants.GET_SHARED_JOB_DETAIL_ACTION_SUCCESS:
      return {
        loggedIn: true,
        sharedJobDetailsData: action.payload,
      };
    case jobsConstants.GET_SHARED_JOB_DETAIL_ACTION_FAILURE:
      return {
        type: "alert-failure",
        error: action.payload,
      };
    default:
      return state;
  }
};

//all jobs reducer
export const get_all_jobs_user_reducer = (state = initialState, action) => {
  switch (action.type) {
    case jobsConstants.GET_ALL_JOBS_USER_ACTION_REQUEST:
      return {
        type: "alert-success",
        message: action.payload,
      };
    case jobsConstants.GET_ALL_JOBS_USER_ACTION_SUCCESS:
      return {
        type: "alert-success",
        allJobsData: action.payload,
      };
    case jobsConstants.GET_ALL_JOBS_USER_ACTION_FAILURE:
      return {
        type: "alert-failure",
        message: action.payload,
      };
    default:
      return state;
  }
};

//job details reducer
export const get_job_details_user_reducer = (state = initialState, action) => {
  switch (action.type) {
    case jobsConstants.GET_JOB_DETAILS_USER_ACTION_REQUEST:
      return {
        type: "alert-success",
        message: action.payload,
      };
    case jobsConstants.GET_JOB_DETAILS_USER_ACTION_SUCCESS:
      return {
        type: "alert-success",
        jobDetailsData: action.payload,
      };
    case jobsConstants.GET_JOB_DETAILS_USER_ACTION_FAILURE:
      return {
        type: "alert-failure",
        message: action.payload,
      };
    default:
      return state;
  }
};

export const invite_user_to_job_reducer = (state = initialState, action) => {
  switch (action.type) {
    case jobsConstants.INVITE_USER_TO_JOB_REQUEST:
      return {
        type: "alert-success",
        message: action.payload,
      };
    case jobsConstants.INVITE_USER_TO_JOB_SUCCESS:
      return {
        type: "alert-success",
        inviteDetailsData: action.payload,
      };
    case jobsConstants.INVITE_USER_TO_JOB_FAILURE:
      return {
        type: "alert-failure",
        message: action.payload,
      };
    default:
      return state;
  }
};

export const get_invited_jobs_user_reducer = (state = initialState, action) => {
  switch (action.type) {
    case jobsConstants.GET_INVITED_JOBS_USER_ACTION_REQUEST:
      return {
        type: "alert-success",
        message: action.payload,
      };
    case jobsConstants.GET_INVITED_JOBS_USER_ACTION_SUCCESS:
      return {
        type: "alert-success",
        invitedJobDetailsData: action.payload,
      };
    case jobsConstants.GET_INVITED_JOBS_USER_ACTION_FAILURE:
      return {
        type: "alert-failure",
        message: action.payload,
      };
    default:
      return state;
  }
};

export const get_all_connected_jobs_reducer = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case jobsConstants.GET_INVITED_JOBS_USER_ACTION_REQUEST:
      return {
        type: "alert-success",
        message: action.payload,
      };
    case hiringManagerJobsConstants.GET_JOBS_HIRING_MANAGER_ACTION_SUCCESS:
    case mentorConstants.GET_MENTOR_DASHBOARD_DETAILS_ACTION_SUCCESS:
    case recruiterJobConstants.GET_ALL_JOBS_RECRUITER_ACTION_SUCCESS:
      return {
        type: "alert-success",
        allConnectedJobsData: action.payload,
      };
    case jobsConstants.GET_INVITED_JOBS_USER_ACTION_FAILURE:
      return {
        type: "alert-failure",
        message: action.payload,
      };
    default:
      return state;
  }
};
